<div class="main-header">
    <div class="logo">
        <img src="./assets/images/logo.png" alt="">
    </div>

    <div class="menu-toggle" (click)="toggelSidebar()">
        <div></div>
        <div></div>
        <div></div>
    </div>

    <div style="margin: auto"></div>

    <div class="header-part-right">
        <span #address class="d-none d-sm-inline-block">{{ user.name }} - 2410 Cruzen St. Suite {{ selectedSuiteCode }}
            Nashville, TN 37211</span>
        <div class="d-none d-sm-inline-block ms-3" ngbDropdown [placement]="'bottom-right'">
            <button ngbDropdownToggle class="btn btn-outline-boombinere" type="button">
                <span></span>{{ selectedSuiteCode }}
            </button>
            <div ngbDropdownMenu>
                <a href="javascript:" *ngFor="let suiteCode of user.suiteCodes" (click)="selectChangeHandler(suiteCode)"
                    class="dropdown-item">Suite {{ suiteCode }}</a>
                <div class="dropdown-divider"></div>
                <a href="javascript:" class="dropdown-item" (click)="copyAddress(address)">Copy
                    Suite Address</a>
            </div>
        </div>
        <div class="d-inline-block d-sm-none" ngbDropdown [placement]="'bottom-right'">
            <button ngbDropdownToggle class="btn btn-outline-boombinere" type="button">
                <span></span>{{ selectedSuiteCode }}
            </button>
            <div ngbDropdownMenu>
                <a href="javascript:" *ngFor="let suiteCode of user.suiteCodes"
                    (click)="selectChangeHandler(suiteCode, modalSuite)" class="dropdown-item">Suite {{ suiteCode }}</a>
            </div>
        </div>

        <div ngbDropdown [placement]="'bottom-right'" class="d-sm-inline-block ms-2 me-2">
            <i ngbDropdownToggle class="i-Gear text-muted header-icon" role="button"></i>
            <div ngbDropdownMenu aria-labelledby="userDropdown" class="header-account-dropdown">
                <div class="dropdown-header">
                    <i class="i-Lock-User mr-1"></i> {{ user.name }}
                </div>
                <button class="dropdown-item" routerLink="/settings/account-info">Account Settings</button>
                <button class="dropdown-item" routerLink="/settings/change-password">Change Password</button>
                <button class="dropdown-item" routerLink="/settings/address-book">Address Book</button>
                <!-- <div *ngIf="user?.migratedFromOldSystem" class="dropdown-divider"></div>
                <button *ngIf="user?.migratedFromOldSystem" class="dropdown-item" (click)="loginOldSystem()">
                    <img src="assets/images/old-logo.png" style="margin-right: 2px; margin-top:-4px;">Old Account
                </button> -->
                <div class="dropdown-divider"></div>
                <button class="dropdown-item" (click)="signout()"><i class="i-Power-2"></i> Sign out</button>
            </div>
        </div>
    </div>

</div>

<ng-template #modalSuite let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Suite Code {{ selectedSuiteCode }}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        </button>
    </div>
    <div class="modal-body">
        <div class="card mb-1">
            <div class="card-body text-center">
                <p #addressModal>{{ user.name }} - 2410 Cruzen St. Suite {{ selectedSuiteCode }}
                    Nashville, TN 37211</p>
                
                <a href="javascript:" class="btn btn-sm btn-primary" (click)="copyAddress(addressModal)">Copy
                    Suite Address</a>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark btn-rounded"
            (click)="modal.close('Save click')">Close</button>
    </div>
</ng-template>